<template>
  <v-card color="grey lighten-3">
    <v-card-text class="pt-5 pb-4 px-5">
      <v-text-field
        solo
        v-model.number="form.promotion_fix_price"
        :rules="[v => !!v || 'Price is required']"
        label="Fix product price (THB)"
        :disabled="isEditPromotion"
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["form"],
  computed: {
    ...mapGetters({
      isEditPromotion: "isEditPromotion"
    })
  }
};
</script>

<style>
</style>
